
const NSS_ADVISOR_BATCH_SIZE = 4;
const nssAdvisorDesktopMQ = window.matchMedia(`(min-width: 990px)`);

function nssAdvisorBindCarousel(el) {
  const carouselEl = el.closest(`nss-carousel`);
  if (!carouselEl || carouselEl.nssAdvisorGridBound) return;
  carouselEl.nssAdvisorGridBound = true;

  const apply = () => {
    const swiper = carouselEl.swiper;
    if (!swiper || swiper.destroyed) return;
    if (nssAdvisorDesktopMQ.matches) {
      swiper.enable();
      swiper.update();
    } else {
      swiper.disable();
    }
  };

  nssAdvisorDesktopMQ.addEventListener(`change`, apply);

  if (carouselEl.swiper) {
    apply();
  } else {
    requestAnimationFrame(apply);
  }
}

let elementName = `nss-carousel-slide-advisor`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSCarouselSlideAdvisor extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Carousel Slide Advisor] Connected.`);

      nssAdvisorBindCarousel(this);
      this.stampDrawer();
    }

    disconnectedCallback() {
      if (this.stampedDrawerEl && this.stampedDrawerEl.isConnected) {
        this.stampedDrawerEl.remove();
      }
    }

    stampDrawer() {
      const templateEl = this.querySelector(`template[nss-advisor-drawer-template]`);
      if (!templateEl) return;

      const drawerEl = templateEl.content.querySelector(`nss-drawer`);
      if (!drawerEl) return;

      const drawerId = drawerEl.getAttribute(`nss-drawer-id`);

      document
        .querySelectorAll(`nss-drawer[nss-drawer-id="${CSS.escape(drawerId)}"]`)
        .forEach((staleEl) => staleEl.remove());

      const hostEl = this.closest(`.shopify-section`) || document.body;
      this.stampedDrawerEl = drawerEl.cloneNode(true);
      hostEl.appendChild(this.stampedDrawerEl);
    }
  }

  customElements.define(elementName, NSSCarouselSlideAdvisor);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}

let viewMoreElementName = `nss-advisor-view-more`;
if (typeof customElements.get(viewMoreElementName) === `undefined`) {
  class NSSAdvisorViewMore extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Advisor View More] Connected.`);

      this.hostEl = this.closest(`li`);
      this.wrapperEl = this.closest(`.swiper-wrapper`);
      this.btnEl = this.querySelector(`[nss-advisor-view-more-btn]`);
      this.countEl = this.querySelector(`[nss-advisor-view-more-count]`);

      nssAdvisorBindCarousel(this);
      this.unregisterAsSlide();

      if (this.btnEl) {
        this.btnEl.addEventListener(`click`, this.handleClick.bind(this));
      }
      this.refresh();
    }

    unregisterAsSlide() {
      const strip = () => {
        if (!this.hostEl) return;
        if (!this.hostEl.classList.contains(`swiper-slide`)) return;
        this.hostEl.classList.remove(`swiper-slide`);
        this.hostEl.style.removeProperty(`width`);
        this.hostEl.style.removeProperty(`margin-right`);
        const carouselEl = this.closest(`nss-carousel`);
        if (carouselEl && carouselEl.swiper && !carouselEl.swiper.destroyed) {
          carouselEl.swiper.update();
        }
      };
      strip();
      requestAnimationFrame(strip);
    }

    get hiddenCells() {
      if (!this.wrapperEl) return [];
      const cellEls = [...this.wrapperEl.querySelectorAll(`li.nss-carousel-slide-advisor`)];
      return cellEls
        .slice(NSS_ADVISOR_BATCH_SIZE)
        .filter((cellEl) => !cellEl.classList.contains(`nss-advisor-revealed`));
    }

    handleClick() {
      if (this.debug) console.log(`[NSS][Advisor View More] Revealing next batch.`);

      this.hiddenCells
        .slice(0, NSS_ADVISOR_BATCH_SIZE)
        .forEach((cellEl) => cellEl.classList.add(`nss-advisor-revealed`));
      this.refresh();
    }

    refresh() {
      const remaining = this.hiddenCells.length;
      if (this.countEl) this.countEl.textContent = `(${remaining})`;
      if (this.hostEl) {
        this.hostEl.classList.toggle(`nss-advisor-view-more--done`, remaining === 0);
      }
    }
  }

  customElements.define(viewMoreElementName, NSSAdvisorViewMore);
} else {
  console.warn(`[NSS] Element '${viewMoreElementName}' already defined.`);
}
